import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'my-terms-of-use',
  template: require('./terms-of-use.component.html'),
  styles: [require('./terms-of-use.component.scss'), require('../shared/styles/form.scss')]
})
export class TermsOfUseComponent implements OnInit {
  domainName: string;
  constructor(
    private loadingService: LoadingService,
    private router: Router,
    private authService: AuthService) {
    // Do stuff
  }

  ngOnInit() {
    console.log('terms of use');
    this.domainName = this.authService.getCurrentDomain();
    this.loadingService.hideLoading();
  }
  gotoLogin() {
    this.router.navigate(['/login']);
  }
  goToHome() {
    alert(this.domainName + '/home');
    this.authService.gotoHome();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/terms-of-use/terms-of-use.component.ts